export const PHONE_MASK = '{+7}{ }000{ }000{-}00{-}00';
